import React, { useState, useEffect } from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import io from "socket.io-client";
import "./Navbar.css";
import { Badge, Divider, Grid, Menu } from "@mui/material";
import { FaAlignLeft } from "react-icons/fa";
import NotificationsIcon from "@mui/icons-material/Notifications";
import API from "../../utils/Axios.utils";
import useStyles from "../../assets/styles/SupMangComp.style";
import AccountPopover from "./AccountPopover";
import useAuth from "../../hooks/useAuth";

const Navbar = ({ toggleSidebar }) => {
  const classes = useStyles();
  const [showLogout, setShowLogout] = useState(false);
  const [notifyCountt, setNotifyCount] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notifyData, setNotifyData] = React.useState([]);
  const [socketResponse, setsocketResponse] = React.useState("");

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const NotifyHandler = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const { token, userId: UserID, user } = useAuth();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getSupplier = async () => {
    try {
      const res = await API.get(
        `/api/users/supplier/notification/${UserID}`,
        config
      );

      const validNotifs = res.data.notifications.filter(
        (item) =>
          item.status !== 0 &&
          (new Date() - new Date(item.createdAt)) / (1000 * 60 * 60 * 24) < 7
      );

      setNotifyData(validNotifs);
      setNotifyCount(validNotifs.length);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSupplier();
  }, [socketResponse]);

  useEffect(() => {
    const socket = io(process.env.REACT_APP_SERVER_SOCKET_URL, {
      path: "/socket.io",
    });

    socket.on("messageFromServer", (data) => {
      console.log("Message from server:", data);
    });

    socket.on("profileAddNotify", (data) => {
      console.log("profile_add:", data);
      setsocketResponse(data);
    });

    socket.on("status", (data) => {
      console.log("statuschanged:", data);
      setsocketResponse(data);
    });

    socket.on("notification", (data) => {
      console.log("Messages:", data);
      setsocketResponse(data);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const isReadNotif = async () => {
    try {
      await API.put(`/api/users/supplier/notification/${UserID}`, {}, config);
    } catch (error) {
      console.log(error);
    }
  };

  const Firstname = user?.first_name;

  const Lastname = user?.last_name;

  const name = Firstname + Lastname;

  return (
    <nav className="navbar_container">
      <Grid container className="navbar-container">
        <Grid
          item
          xl={9}
          lg={9}
          md={9}
          sm={6}
          xs={6}
          className="navbar-container-notification"
        >
          <button type="button" className="toggle-btn" onClick={toggleSidebar}>
            <FaAlignLeft />
          </button>
        </Grid>

        <Grid
          item
          xl={3}
          lg={3}
          md={3}
          sm={6}
          xs={6}
          className="navbar-container-user"
        >
          <div style={{ marginRight: "20px" }}>
            <button
              className="NavsecondNotifBtn"
              onClick={(e) => {
                NotifyHandler(e);
                isReadNotif();
              }}
            >
              <Badge badgeContent={notifyCountt.toString()} color="error">
                <NotificationsIcon
                  sx={{ fontSize: "25px", color: "#3E97FF" }}
                />
              </Badge>
            </button>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              sx={{
                "& .MuiPopover-paper": {
                  overflowX: "unset !important",
                  overflowY: "unset !important",
                },
              }}
            >
              {notifyData?.length === 0 ? (
                <div className="NavNoNotificationDiv">
                  <Grid container style={{ padding: "10px" }}>
                    <Grid item xs={12}>
                      <div
                        className="Navdes_text"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        No Notifications
                      </div>
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <div className={classes.scrollbar}>
                  {notifyData.map((list, i) => {
                    const now = new Date();
                    const createdDate = new Date(list.createdAt);
                    const timeDifferenceMs = now - createdDate;
                    const hoursDifference = Math.round(
                      timeDifferenceMs / (1000 * 60 * 60)
                    );

                    let outputMessage = "";
                    if (hoursDifference < 24) {
                      outputMessage = `${hoursDifference} Hours ago`;
                    } else {
                      const daysDifference = Math.floor(hoursDifference / 24);
                      outputMessage = `${daysDifference} Days ago.`;
                    }

                    return (
                      <div key={i}>
                        <Grid container style={{ padding: "10px" }}>
                          <Grid item xs={12}>
                            <div className="Navdes_text">{list.message}</div>
                            <div className="NavTime_text">{outputMessage}</div>
                          </Grid>
                        </Grid>
                        <Divider sx={{ margin: "10px" }} />
                      </div>
                    );
                  })}
                </div>
              )}
            </Menu>
          </div>

          {/* <AccountCircleOutlinedIcon className="navbar-user-avtar" /> */}

          {/* <div className="btn-container">
            <span
              className="navbar-userName"
              onClick={() => {
                setShowLogout(!showLogout);
              }}
            >
              {name ? name : "User"}
            </span>
          </div> */}
          <AccountPopover />
        </Grid>
      </Grid>
    </nav>
  );
};

export default Navbar;
